import { useState } from "react";
import GenerateAuthorizationModal from "./GenerateAuthorizationModal";
import AuthorizationLinkModal from "./AuthorizationLinkModal";

interface C6BankModalProps {
  onBack: () => void;
  onClose?: () => void;
}

export default function C6BankModal({ onBack, onClose }: C6BankModalProps) {
  const [step, setStep] = useState<"generate" | "authorizationLink">(
    "generate",
  );

  if (step === "generate") {
    return (
      <GenerateAuthorizationModal
        onBack={onBack}
        onContinue={() => setStep("authorizationLink")}
      />
    );
  }

  if (step === "authorizationLink") {
    return <AuthorizationLinkModal onClose={onClose || onBack} />;
  }

  return null;
}
